import React, { useEffect, useRef, useState } from 'react'
import Draggable from 'react-draggable'
import { useDispatch, useSelector } from 'react-redux'
import { BASE_URL } from '../../../utils/environment'
import GET_API_KEY from '../../../utils/getApiKey'
import { WellDonePopup } from './WellDonePopup'

export const TimeTracker = ({ sessionId }) => {
    const { timeTrackerData } = useSelector((state) => state.timeTracker)
    const [playingDuration, setPlayingDuration] = useState(0)
    const [timerId, setTimerId] = useState(0)
    const [timerCounting, setTimerCounting] = useState(false)
    const [intervalProgressBar, setIntervalProgressBar] = useState(0)
    const [barPlayingDuration, setBarPlayingDuration] = useState(0)
    const [showWellDonePopup, setShowWellDonePopup] = useState(false)

    const startTimer = () => {
        const interval = setInterval(() => {
            setPlayingDuration((prev) => prev + 1)
        }, 1000 * 30)

        const intervalProgressBar = setInterval(() => {
            setBarPlayingDuration((prev) => prev + 1)
        }, 1000)
        setTimerId(interval)
        setIntervalProgressBar(intervalProgressBar)
    }

    useEffect(() => {
        if (playingDuration === 0) {
            return
        }
        sendTimeData()
    }, [playingDuration])

    const stopTimer = () => {
        clearInterval(timerId)
        clearInterval(intervalProgressBar)
        setTimerCounting(true)
    }

    // Leaving the activity (or the page) stops both counters: refs, so the cleanup only runs when the timer goes away.
    const timers = useRef({})
    timers.current = { timerId, intervalProgressBar }
    useEffect(
        () => () => {
            clearInterval(timers.current.timerId)
            clearInterval(timers.current.intervalProgressBar)
        },
        []
    )

    useEffect(() => {
        if (
            window.location.pathname.indexOf(timeTrackerData.gameName) > 1 &&
            timeTrackerData.remainingDuration > 0
        ) {
            startTimer()
            setTimerCounting(true)
        } else {
            stopTimer()
            setTimerCounting(false)
            clearInterval(intervalProgressBar)
        }
    }, [window.location.pathname, timeTrackerData])

    const sendTimeData = () => {
        const axios = require('axios')
        const data = JSON.stringify({
            student_id: timeTrackerData.studentId,
            game_id: timeTrackerData.gameId,
            played_time: 30,
            is_completed:
                playingDuration * 30 >= timeTrackerData.remainingDuration
                    ? 1
                    : 0,
            session_id: sessionId,
            assignment_id: timeTrackerData.assignmentId,
        })
        const apiKey = GET_API_KEY()
        const url = BASE_URL + 'games/record-played-time'
        const config = {
            method: 'post',
            url,
            headers: {
                Authorization: `Bearer ${apiKey}`,
                'Content-Type': 'application/json',
            },
            data: data,
        }

        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data))
                if (playingDuration * 30 >= timeTrackerData.remainingDuration) {
                    stopTimer()
                    setTimerCounting(false)
                    setShowWellDonePopup(true)
                }
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    // Time left for this activity's minutes, from the seconds counted since it opened (the bar counts every second).
    const total = Math.max(1, timeTrackerData.remainingDuration || 0)
    const leftSeconds = Math.max(0, total - barPlayingDuration)
    const clock = `${Math.floor(leftSeconds / 60)}:${String(leftSeconds % 60).padStart(2, '0')}`
    const ring = 2 * Math.PI * 20
    const share = Math.min(1, barPlayingDuration / total)

    return (
        <>
            {timerCounting && (
                <Draggable position={null} defaultPosition={{ x: 0, y: 0 }} defaultClassName="react-draggable-widget">
                    <div>
                        <div className="stu-timer" role="timer" aria-label={`${clock} of practice left`}>
                            <svg className="stu-timer-ring" viewBox="0 0 48 48" width="44" height="44" aria-hidden="true">
                                <circle cx="24" cy="24" r="20" fill="none" stroke="#e5eef6" strokeWidth="6" />
                                <circle
                                    cx="24"
                                    cy="24"
                                    r="20"
                                    fill="none"
                                    stroke="#3C9BD5"
                                    strokeWidth="6"
                                    strokeLinecap="round"
                                    strokeDasharray={ring}
                                    strokeDashoffset={ring * (1 - share)}
                                    transform="rotate(-90 24 24)"
                                />
                            </svg>
                            <span className="stu-timer-text">
                                <b>{clock}</b>
                                <small>left to practice</small>
                            </span>
                        </div>
                    </div>
                </Draggable>
            )}
            {showWellDonePopup && (
                <WellDonePopup setShowWellDonePopup={setShowWellDonePopup} />
            )}
        </>
    )
}
